import SecurityPage from "@features/security/components/SecurityPage";
import { requireAnyPermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Shield } from "lucide-react";

/**
 * Module pattern, not a permission code: PermissionCode.php never declares a
 * wildcard, so PERMISSIONS.* cannot express it (see RH_MODULE_WILDCARD in
 * capabilities/rh.ts). `security.*` = "any permission of the security module".
 */
const SECURITY_MODULE_PATTERN = "security.*";

/**
 * Security Module Route
 *
 * Parent route for the security admin section (Users, Profiles, Permissions).
 * Guarded by ANY `security.*` permission — a partial profile holding only e.g.
 * `security.profiles.view` must reach its own child routes, which the previous
 * `security.users.view` gate blocked before their guards could run
 * (audit 17 §1.1, PLAN-admin-module Tâche 6.2 / W9). Child routes keep their
 * finer-grained per-feature guards.
 */
export const Route = createFileRoute("/_app/admin")({
  loader: requireAnyPermission([SECURITY_MODULE_PATTERN], {
    redirectTo: "/unauthorized",
  }),
  staticData: {
    title: "Sécurité",
    icon: Shield,
    tab_icon: Shield,
    permission: PERMISSIONS.SECURITY.USERS.VIEW,
    module: "security",
    section: "Administration",
    order: 95,
    // The index route carries the nav entry (routing.md §16) — a second
    // showInNav here would normalize to the same "/admin" path as index.tsx.
    showInNav: false,
    showInBreadcrumb: true,
    description: "Module Sécurité",
  },
  component: SecurityPage,
});
